import React, { useState } from 'react';
import {
  MasterDetailForm,
  Widget,
  FormInput,
  FormDatePicker,
  usePromise,
  FormNumber,
  Icon,
  ButtonDelete,
  FormSubmitButton,
  FormatText,
  Button,
} from '@digital/ui';
import { Collapse } from 'antd';
import * as Yup from 'yup';
import {
  getDocumentoCobrancaWithParcelas,
  DocumentoCobranca,
} from '../../../api/autorizacaoPagamento/documentoCobranca';
import {
  Autorizacao,
  getAutorizacaoById,
  updateDataAutorizacao,
  sendToFornecedor,
  deleteAutorizacao,
  urlDownloadArquivo,
} from '@app/api/autorizacaoPagamento/autorizacao';
import ModalAnexarArquivoAutorizacao from './modalAnexarArquivoAutorizacao';
import DocumentosCobrancaTable from './documentosCobrancaTable';
import CartasCorrecaoTable from './cartasCorrecaoTable';
import ParcelasPagamentoTable from './parcelasPagamentoTable';
import { hasPermission } from '@app/helpers/permissions';
import { currencyFormat } from '@app/helpers/numbers';
import ComprovantesCancelamentoTable from './comprovantesCancelamentoTable';
import { getLoggedIsMRN } from '@app/helpers';

const AutorizacaoContainer = (props: {
  autorizacaoId: string;
  onUpdate: Function;
  usuarioLogadoFinanceiroDoContratoFornecedor: boolean;
  aprovacaoEPagamentoAutomatica: boolean;
}) => {
  const { autorizacaoId, onUpdate, usuarioLogadoFinanceiroDoContratoFornecedor, aprovacaoEPagamentoAutomatica } = props;
  const [update, setUpdate] = useState();
  const { Panel } = Collapse;

  const [autorizacaoData] = usePromise(
    async () => {
      return autorizacaoId ? await getAutorizacaoById(autorizacaoId) : Promise.resolve(undefined);
    },
    [autorizacaoId, update],
    {} as Autorizacao,
  );

  const [documentoCobranca] = usePromise(
    () => {
      return autorizacaoId ? getDocumentoCobrancaWithParcelas(autorizacaoId) : Promise.resolve(undefined);
    },
    [autorizacaoId],
    {} as DocumentoCobranca,
  );

  const handleSendToFornecedor = () => {
    sendToFornecedor(autorizacaoData.medicaoId, autorizacaoId).then(resp => {
      if (resp.valid) {
        setUpdate(null);
        setUpdate(true);
        onUpdate();
      }
    });
  };

  const handleDeleteAutorizacao = () => deleteAutorizacao(autorizacaoId).then(resp => onUpdate());

  return (
    <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
      <Panel
        key="autorizacao"
        header={'Autorização ' + autorizacaoData.numeroAutorizacao + ' - ' + autorizacaoData.status}>
        <MasterDetailForm
          onSubmit={updateDataAutorizacao}
          initialValues={autorizacaoData}
          validationSchema={Yup.object().shape({})}>
          <Widget
            title="Dados da autorização"
            actions={[
              autorizacaoData.statusCodigo == 1 &&
                aprovacaoEPagamentoAutomatica == false &&
                !autorizacaoData.planilhaRateioId &&
                hasPermission(['MEDICAO_AUTORIZACAO_PAGAMENTO_DELETAR']) && (
                  <ButtonDelete
                    icon={null}
                    disabled={!hasPermission(['MEDICAO_AUTORIZACAO_PAGAMENTO_DELETAR'])}
                    type="link"
                    confirm="Deseja realmente excluir esta autorização?"
                    okText="Confirmar"
                    onClick={handleDeleteAutorizacao}
                  />
                ),

              // autorizacaoData.statusCodigo == 1 &&
              // aprovacaoEPagamentoAutomatica == false &&
              // hasPermission(['MEDICAO_AUTORIZACAO_PAGAMENTO_EDITAR']) &&
              // (
              //   <FormSubmitButton
              //     disabled={!hasPermission(['MEDICAO_AUTORIZACAO_PAGAMENTO_EDITAR'])}
              //     type="primary">
              //     <FormatText id="ui.commons.save" uppercase />
              //   </FormSubmitButton>
              // ),

              autorizacaoData.statusCodigo == 1 &&
                aprovacaoEPagamentoAutomatica == false &&
                hasPermission(['MEDICAO_AUTORIZACAO_PAGAMENTO_ENVIAR_PARA_FORNECEDOR']) && (
                  <Button
                    disabled={!hasPermission(['MEDICAO_AUTORIZACAO_PAGAMENTO_ENVIAR_PARA_FORNECEDOR'])}
                    type="primary"
                    onClick={handleSendToFornecedor}>
                    Enviar Para Fornecedor
                  </Button>
                ),
            ]}>
            <FormInput label="Documento de Cobrança" name="tipoDocumentoCobranca" span={6} disabled />
            <FormInput label="Estabelecimento" name="estabelecimento" span={6} disabled />
            <FormNumber formatter={currencyFormat} label="Valor" name="valor" span={3} disabled />
            <FormDatePicker label="Data de Autorização" name="dataAutorizacao" format="DD/MM/YYYY" span={3} disabled />
            <FormInput label="Nº Documento de Cobrança" name="documentoCobrancaNumero" disabled span={3} />
            <FormInput label="Matching ERP" name="matchingERP" span={3} disabled />
          </Widget>
        </MasterDetailForm>

        <Widget title="Documento de Cobrança">
          {autorizacaoData ? (
            autorizacaoData.arquivosAutorizacao != undefined &&
            autorizacaoData.arquivosAutorizacao.length == 0 &&
            (getLoggedIsMRN() || autorizacaoData.statusCodigo == 2) ? (
              <ModalAnexarArquivoAutorizacao
                autorizacaoId={autorizacaoData.id}
                setUpdate={setUpdate}
                autorizacaoData={autorizacaoData}
              />
            ) : null
          ) : null}

          {autorizacaoData ? (
            autorizacaoData.arquivosAutorizacao != undefined && autorizacaoData.arquivosAutorizacao.length > 0 ? (
              <DocumentosCobrancaTable
                usuarioLogadoFinanceiroDoContratoFornecedor={usuarioLogadoFinanceiroDoContratoFornecedor}
                setUpdate={setUpdate}
                arquivos={autorizacaoData.arquivosAutorizacao}
              />
            ) : null
          ) : null}
        </Widget>

        {autorizacaoData ? (
          autorizacaoData.parcelasPagamento != undefined && autorizacaoData.parcelasPagamento.length > 0 ? (
            <Widget title="PREVISÃO DE PAGAMENTO">
              <ParcelasPagamentoTable setUpdate={setUpdate} arquivos={autorizacaoData.parcelasPagamento} />
            </Widget>
          ) : null
        ) : null}

        {autorizacaoData ? (
          autorizacaoData.arquivosComprovanteCancelamento != undefined &&
          autorizacaoData.arquivosComprovanteCancelamento.length > 0 ? (
            <Widget title="Comprovantes de cancelamento">
              <ComprovantesCancelamentoTable arquivos={autorizacaoData.arquivosComprovanteCancelamento} />
            </Widget>
          ) : null
        ) : null}

        {autorizacaoData ? (
          autorizacaoData.arquivosCartaCorrecao != undefined && autorizacaoData.arquivosCartaCorrecao.length > 0 ? (
            <Widget title="Cartas de correção">
              <CartasCorrecaoTable arquivos={autorizacaoData.arquivosCartaCorrecao} />
            </Widget>
          ) : null
        ) : null}

        {/* <MasterDetailForm initialValues={documentoCobranca}>
          <Widget>
            <fieldset>
              <legend>Detalhes do Documento de Cobrança</legend>
              <FormInput label="Documento de Cobrança" name="tipo" span={4} disabled required />
              <FormInput label="Estabelecimento" name="estabelecimento" span={4} disabled required />
              <FormInput label="Valor" name="valor" span={4} disabled required />
              <FormInput label="Número do Contrato" name="numeroContrato" span={4} disabled required />
              <FormInput label="Fornecedor" name="fornecedor" span={4} disabled required />
              <FormInput label="Natureza" name="natureza" span={4} disabled required />
              <FormInput label="Série" name="serie" span={4} disabled required />
              <FormInput label="Quantidade de Parcelas" name="qtdParcela" span={4} disabled required />
              <FormTextArea
                label="Condição de Pagamento"
                name="condicaoPagamento"
                span={12}
                rows={4}
                disabled
                required
              />
            </fieldset>
          </Widget>
        </MasterDetailForm> */}

        {/* <ParcelaTable dataSource={documentoCobranca.parcelas} /> */}
      </Panel>
    </Collapse>
  );
};

export default AutorizacaoContainer;
